export default class ProductSize {
    ID!: string;
    package!: string;
    unit!: string;

    get getPackage() {
        return `${this.package} ${this.unit}`;
    }
}
